import * as React from 'react';
import classNames from 'classnames';
import { Tabs as BaseTabs } from '@mc/react-core';

type Props = React.ComponentProps<typeof BaseTabs>;

const ClassName = `tabs tabs-sidepanel`;

export class SidePanelTabs extends React.PureComponent<Props> {
  render() {
    const { className, vertical, ...other } = this.props;
    return (
      <BaseTabs
        vertical
        {...other}
        className={classNames(ClassName, className)}
      />
    );
  }
}
